import { jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M7.757 2.03a1 1 0 0 1 1.213.727L9.78 6h4.44l.81-3.243a1 1 0 1 1 1.94.486L16.28 6H17a3 3 0 0 1 3 3v.586l.707.707A1 1 0 0 1 21 11v3a1 1 0 0 1-.293.707l-.707.707V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-2.586l-.707-.707A1 1 0 0 1 3 14v-3a1 1 0 0 1 .293-.707L4 9.586V9a3 3 0 0 1 3-3h.72l-.69-2.757a1 1 0 0 1 .727-1.213M7 11.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m8.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M10 15a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
